import { render, staticRenderFns } from "./formBuilder.vue?vue&type=template&id=b5b0aa30&scoped=true&"
import script from "./formBuilder.vue?vue&type=script&lang=js&"
export * from "./formBuilder.vue?vue&type=script&lang=js&"
import style0 from "./formBuilder.vue?vue&type=style&index=0&id=b5b0aa30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b0aa30",
  null
  
)

export default component.exports